import React from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'

import { maskString, toCamelCase } from 'utils/stringUtils'

const ListItem = ({ merchant }) => {
  const { name, merchantAccountId, merchantType, uuid } = merchant
  const history = useHistory()

  const onMerchantClick = () =>
    history.push({
      state: { merchantUuid: uuid },
    })

  return (
    <div className="item">
      <div className="row" onClick={onMerchantClick} role="button">
        <div className="item-info-wrapper -bold">{name}</div>
        <div className="item-info-wrapper">
          {maskString(merchantAccountId)}
        </div>
        <div className="item-info-wrapper">
          {merchantType ? toCamelCase(merchantType) : 'None'}
        </div>
      </div>
    </div>
  )
}

ListItem.propTypes = {
  merchant: PropTypes.object,
}

export default ListItem
